export enum AccordionState {
  VALIDATED,
  CURRENT,
  PENDING
}

export type Address = {
  address1: string;
  address2: string;
  postalCode: string;
  city: string;
  state: string;
  neighborhood: string;
  country: string;
};

export type Document = {
  passport: File | null;
  document1: File | null;
  proveAddress: File | null;
};

export interface UserInfos {
  id?: number;
  name: string;
  occupation: string;
  document_number: string;
  documentType?: 'national_id' | 'drivers_license' | '';
  addressProofOwner?: 'self' | 'other' | '';
  addressProofKinship?: string;
  gender: string;
  dateOfBirth: string;
  phone: string;
  ddi: string;
  email: string;
  nationality: string;
  passportNo: string;
  expiryDate: string;
  passportIssueCountry: string;
  issueDate: string;
  address1: string;
  address2: string;
  postalCode: string;
  city: string;
  state: string;
  neighborhood: string;
  country: string;
  shareIssuanceDate: string;
  classOfShares: string;
  numberOfShares: string;
  sharesValue: string;
  privileges?: string;
  conditions?: string;
  passport: File | null;
  document1: File | null;
  proveAddress: File | null;
  passportExistingName?: string;
  document1ExistingName?: string;
  proveAddressExistingName?: string;
}

export type Shareholder = {
  name: string;
  occupation: string;
  gender: string;
  dateOfBirth: string;
  phone: string;
  ddi: string;
  email: string;
  nationality: string;
  passportNo: string;
  expiryDate: string;
  passportIssueCountry: string;
  issueDate: string;
  shareIssuanceDate: string;
  classOfShares: string;
  numberOfShares: string;
  sharesValue: string;
  privileges?: string;
  conditions?: string;
  address: Address[]; // Adicionando subtipo `Address`
  documents: Document; // Adicionando subtipo `Document`
};

export type ShareholderData = {
  state: any;
  id: number;
  name: string;
  email: string;
  gender: string;
  date_of_birth: string;
  nationality: string;
  occupation: string;
  document_number: string;
  dateOfBirth: string;
  phone: string;
  ddi: string;
  passportNo: string;
  expiryDate: string;
  passportIssueCountry: string;
  issueDate: string;
  address: Array<{
    address: string;
    complement: string;
    city: string;
    postal_code: string;
    country: string;
    neighborhood: string;
    state: string;
    belongs_to_shareholder?: boolean | null;
    relationship_degree?: string | null;
    meta_data: any;
  }>;
  documents: Array<{
    document_name: string;
    document_url: string;
    description: string;
    document_type?: string | null;
    meta_data: any;
  }>;
  passports: Array<{
    number: string;
    expiry_date: string;
    issuing_country: string;
    issuing_date: string;
    description: string;
    meta_data: any;
  }>;
  telephones: Array<{
    DDI: string;
    DDD: string;
    number: string;
  }>;
  shareIssuanceDate: string;
  classOfShares: string;
  number_of_shares: string;
  sharesValue: string;
  privileges?: string;
  conditions?: string;
};

export type FormValues = {
  shareholders: UserInfos[];
};

export type GetFormValues = {
  shareholders: ShareholderData[];
};

// export type ShareholderFieldKey<T extends keyof FormValues['shareholders'][number]> = `shareholders.${number}.${T}`;

export type ShareholderFieldKey =
  | `shareholders.${number}.name`
  | `shareholders.${number}.occupation`
  | `shareholders.${number}.gender`
  | `shareholders.${number}.phone`
  | `shareholders.${number}.ddi`
  | `shareholders.${number}.email`
  | `shareholders.${number}.nationality`
  | `shareholders.${number}.passportNumber`;
